import { Component, OnInit, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { JqHelper } from 'src/app/common/jq-helper';
import { G_SaleMasterViewModel } from 'src/app/viewmodels/g-sale/G_SaleMasterViewModel';
import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import { GItemDefiningViewModel } from 'src/app/viewmodels/g-item/GItemDefiningViewModel';
import { GVechileViewModel } from 'src/app/viewmodels/g-vehicle/GVechileViewModel';
import { G_PurchaseMasterViewModel } from 'src/app/viewmodels/g-purchase/G_PurchaseMasterViewModel';
import { PurchaseDetailViewModel } from 'src/app/viewmodels/g-purchase/PurchaseDetailViewModel';
import { GPackagesViewModel } from 'src/app/viewmodels/g-packages/GPackagesViewModel';
import { GPackageItemViewModel } from 'src/app/viewmodels/g-packages/GPackageItemViewModel';
import { GPackagesModelViewModel } from 'src/app/viewmodels/g-packages/GPackagesModelViewModel';
import { ActivatedRoute, Router } from '@angular/router';
import { G_ComplainsSuggestionsViewModel } from 'src/app/viewmodels/g-settings/G_ComplainsSuggestionsViewModel';
import { AccountDefiningModel, DefineAccountviewModel } from 'src/app/viewmodels/g-customer/DefineAccountviewModel';
import { G_TagsViewModel } from 'src/app/viewmodels/g-settings/G_TagsViewModel';
import { SaleDetailViewModel } from 'src/app/viewmodels/g-sale/SaleDetailViewModel';
import { G_PackagesTypeViewModel } from 'src/app/viewmodels/g-packages/G_PackagesTypeViewModel';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';
import { NgxSpinner } from 'ngx-spinner/lib/ngx-spinner.enum';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalStorageService } from 'src/app/services/common/local-storage.service';
import { ComplainsSuggestionsModel, GPackagesModel, SaleDetailModel, SaveSaleMasterRequest, TagsModel } from 'src/app/viewmodels/g-purchase/GPurchaseViewModel';
import { GPackageItemModel, SaveGVehicleRequest, SaveItemRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';


@Component({
  selector: 'app-repair-order',
  templateUrl: './repair-order.component.html',
  styleUrls: ['./repair-order.component.scss']
})
export class RepairOrderComponent implements OnInit {
  public maxSelection: number = 1;
  modalRef: BsModalRef;
  selectedFile = null;
  public vmListItems: any = [];
  private submitted = false;
  @Input() public vmC: ComplainsSuggestionsModel;
  @Input() public vmD: AccountDefiningModel;
  @Input() public vmP: GPackagesModel;
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  @Output() onSubmitted = new EventEmitter<any>(); public component_Title = 'Sale';
  public vehicleDetail: any = [];
  public packageSparePart: any = [];
  public complaintsType: any = [];
  public ccomplaintsType: 'complaintsType';
  public findingsType: any = [];
  public cfindingsType: 'findingsType';
  public packageTypes: any = [];
  public cvehicleDetail = 'vehicleDetail';
  public selectedvehicleDetail: any = [];
  public itemVm: SaveGVehicleRequest = new SaveGVehicleRequest();
  public sparePartVm: SaveItemRequest = new SaveItemRequest();
  public vm: SaveSaleMasterRequest = new SaveSaleMasterRequest();
  public services: any = [];
  public selectedServices: any = [];
  public selectedItemServices: any = [];
  public SelectedItemSparePArts: any = [];
  public cpackageTypes = 'packageTypes';
  public items: any = [];
  public brands: any = [];
  public selectedBrands: any = [];
  public models: any = [];
  public selectedModels: any = [];
  public citems: any = 'items';
  public cbrands: any = 'brands';
  public cmodels: any = 'models';
  public spareParts: any = [];
  public selectedSpareParts: any = [];
  public selectedPacakgeTypes: any = [];
  public selectedComplaint: any = [];
  public selectedFindings: any = [];
  public selectedTagsList: any = [];
  public tags: any = [];
  public show: boolean = false;
  public buttonName: any = 'Show';
  public isPreview: boolean = false;
  files: File[] = [];
  public date: Date;
  public thumbnail: any;
  public ComName: any;
  public Address: any;
  public contect: any;

  public brandsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 4,
    allowSearchFilter: true
  };
  public modelsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 4,
    allowSearchFilter: true
  };
  public itemsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 4,
    allowSearchFilter: true,
  };
  public PackageSelectionDropdown: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    limitSelection: 1
  };
  public modelid: any;
  public itemTypes = [];
  public ssItemVm = new GItemDefiningViewModel();
  public defaultDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'registrationNumber',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  public selectspp: any;
  SelectedSpare: any[];
  //SelectedServices: any;
  name = 'cpEmail';
  id = 'id';
  checked = true;
  disabled = false;
  label = 'Toggle On/Off';
  labelledby = 'Some Other Text';
  public client: any;
  constructor(
    private route: ActivatedRoute,
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private http: HttpClient,
    public _router: Router,
    private spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService
  ) { }



  ngOnInit() {
    debugger
    this.client = this._localStorageService.get("com");
    this.getimage();
    //this.getItems();
    this.getItemtypes();
    this.getComplaints();
    this.getBrands();
    this.getTags();
    this.getRefid();
    //this.getSpareParts();

    let date = new Date();
    document.getElementById("date").innerHTML = date.toLocaleDateString();

    this.itemVm = new SaveGVehicleRequest();
    let id = this.route.snapshot.params['id'];
    this.spinner.show();
    this._uow.gSettingService.GetGVehicleByIdAsync(id).subscribe((res: any) => {
      this.itemVm = res;
      debugger
      this.itemVm.model = new ItemViewModel1(res.model.id, res.model.name);
      this.modelid = this.itemVm.model;
      this.itemVm.customer = new ItemViewModel1(res.customer.id, res.customer.name);
      this.itemVm.customerEmail = new ItemViewModel1(res.customerEmail.id, res.customerEmail.name)
      this.spinner.hide();
      this.getPackageTypes();
      this.getSparePartsAndServices();

    }, (err) => {
      console.log(err);
      this.spinner.hide();

    })
    if (this.vmD == undefined) {
      this.vmD = new AccountDefiningModel();
      this._uow.gSettingService.LoadAccountFormAsync().subscribe((res: any) => {
        this.vmD = res;
      }, (err) => {
        console.log(err);
      });
    }
    if (this.vmP == undefined) {
      this.vmC = new ComplainsSuggestionsModel();
      this.vmP = new GPackagesModel();
      this.vmP.services = [];
      this.vmP.spareParts = [];
      this.selectedPacakgeTypes = [];
    } else {

      if (this.vmP.services !== undefined && this.vmP.services.length > 0) {
        this.vmP.services.forEach(x => {
          this.selectedServices.push(new ItemViewModel1(x.ssItemDefining.id, x.ssItemDefining.name));
        });
      }
      if (this.vmP.spareParts !== undefined && this.vmP.spareParts.length > 0) {
        this.vmP.spareParts.forEach(x => {
          this.selectedSpareParts.push(new ItemViewModel(x.ssItemDefining.id, x.ssItemDefining.name));
        });
      }
      if (this.vm.salesTagsList !== undefined && this.vm.salesTagsList.length > 0) {
        this.vm.salesTagsList.forEach(x => {
          this.selectedTagsList.push(new ItemViewModel1(x.id, x.name));
        });
      }
      if (this.vmP.gPackagesModel !== undefined && this.vmP.gPackagesModel.length > 0) {
        this.vmP.gPackagesModel.forEach(x => {
          this.selectedPacakgeTypes.push(new ItemViewModel1(x.pacakage.id, x.pacakage.name));
        });
      }
      if (this.vm.customerComplains !== undefined && this.vm.customerComplains.length > 0) {
        this.vm.customerComplains.forEach(x => {

          this.selectedComplaint.push(new ItemViewModel1(x.gComplains.id, x.gComplains.name));
        });
      }
      if (this.vm.findings !== undefined && this.vm.findings.length > 0) {
        this.vm.findings.forEach(x => {
          this.selectedFindings.push(new ItemViewModel1(x.gComplains.id, x.gComplains.name));
        });
      }
    }
    if (this.modal_title == undefined) {
      this.modal_title = 'Package';
    }

  }

  onSelect(e) {
    this.files.push(...e.addedFiles);
    this.vm.file = this.files;
    console.log(e.addedFiles);
  }

  onChange(e) {
    debugger
    let item = this.itemVm.customerEmail;
    if (e == true) {
      this.vm.customerAccEmail = new ItemViewModel1(item.id, item.name);
      this.vm.isEmailRequired = true;
    } else {
      this.vm.customerAccEmail = null;
      this.vm.isEmailRequired = false;
    }
  }

  getRefid() {
    this._uow.gSaleService.GetGSaleRefIdAsync().subscribe(
      (res: any) => {
        console.log(res);
        this.vm.refId = res.code;
      },
      (error) => {
        console.log(error);
      }
    );
  }
  getimage() {

    this._uow.gSettingService.GetHeaderFootersDropDownAsync().subscribe((baseImage: any) => {
      console.log(baseImage);
      debugger;
      if (baseImage != undefined && baseImage !== null) {
        if (baseImage.attachment != undefined && baseImage.attachment !== null) {

          this.thumbnail = `https://fleetdesks.s3.eu-central-1.amazonaws.com/${baseImage.attachment}`;
          this.ComName = baseImage.compName;
          this.Address = baseImage.address;
          this.contect = baseImage.contact;
        } else {
          this.thumbnail = baseImage.compName;
          this.ComName = baseImage.compName;
          this.Address = baseImage.address;
          this.contect = baseImage.contact;
        }
      }
    }, (err) => {
      console.log(err);
    })
  }

  getItemtypes() {
    this._uow.gSettingService.GetItemTypesAsync().subscribe((res: any) => {
      this.itemTypes = res.result;
      console.log(res);
    }, (err) => this._uow.logger.log(err));
  }

  getComplaints() {
    this._uow.gSettingService.GetComplainsAsync().subscribe((res: any) => {
      this.complaintsType = [];
      this.complaintsType = res.result;
      this.findingsType = [];
      this.findingsType = res.result;
      this._uow.logger.log(res);

    }, (error) => {
      this._uow.logger.log(error);
      this._jq.showSpinner();
    });
  }

  getBrands() {
    this._uow.gSettingService.GetGBrandsAsync().subscribe((res: any) => {
      this.brands = res.result;
    }, (err) => {
      this.brands = [];
      this._uow.logger.log(err);
      this._jq.showSpinner();
    });
  }

  getTags() {
    this._jq.showSpinner(true);
    this._uow.gSettingService.GetTagsAsync().subscribe((res: any) => {
      this.tags = res.result;
      this._jq.showSpinner();
    },
      (err) => {
        console.log(err);
        this._jq.showSpinner();
      });
  }

  getPackageTypes() {
    debugger
    let modelid = this.itemVm.model.id;
    this._uow.gSettingService.GetPackageByModelIdAsync(modelid).subscribe((res: any) => {
      this.packageTypes = res.result;
      this._uow.logger.log(res);

    }, (error) => {
      this._uow.logger.log(error);
      this.packageTypes = [];
    });
  }

  getSparePartsAndServices() {
    let modelid = this.itemVm.model.id;
    this._jq.showSpinner(true);
    this._uow.gSettingService.GetItemsDropDownByModelAndTypeIdAsync(modelid, 0).subscribe((res: any) => {
      this.spareParts = res.result;
      console.log(res);
    }, (err) => {
      this._uow.logger.log(err);
      this.spareParts = [];
    });
    // 'Services'
    this._uow.gSettingService.GetItemsDropDownByTypeAsync('Services').subscribe((res: any) => {
      debugger
      this.services = res.result;
      console.log(res);
      this._jq.showSpinner();
      // this._uow.logger.log(`services ${res}`);
    }, (err) => {
      this._uow.logger.log(err);
      this.services = [];
      this._jq.showSpinner();
    });
  }

  onRemove(e) {
    console.log(e);
    this.files.splice(this.files.indexOf(e), 1);
  }

  toggle() {
    this.show = !this.show;
    !this.show == this.show;
  }

  // Complaints
  onSelectComplaints(e) {
    if (this.vm.customerComplains == undefined || this.vm.customerComplains.length == 0) {
      this.vm.customerComplains = [];
    }

    this._uow.logger.log(e);
    let item = this.complaintsType.find(x => x.id === e.id);
    if (item !== undefined) {
      let i = new ComplainsSuggestionsModel();
      i.name = item.name;
      i.gComplains = new ItemViewModel1(item.id, item.name);
      this.vm.customerComplains.push(i);
    }
  }

  onDeSelectComplaints(e) {
    let i = this.vm.customerComplains.find(x => x.gComplains.id === e.id);
    if (i !== undefined) {
      this.vm.customerComplains.splice(this.vm.customerComplains.indexOf(i), 1);
    }

  }

  // Findings
  onSelectFindings(e) {
    if (this.vm.findings == undefined || this.vm.findings.length == 0) {
      this.vm.findings = [];
    }

    this._uow.logger.log(e);
    let item = this.findingsType.find(x => x.id === e.id);
    if (item !== undefined) {
      let i = new ComplainsSuggestionsModel();
      i.name = item.name;
      i.gComplains = new ItemViewModel1(item.id, item.name);
      this.vm.findings.push(i);
    }
  }

  onDeSelectFindings(e) {
    let i = this.vm.findings.find(x => x.gComplains.id === e.id);
    if (i !== undefined) {
      this.vm.findings.splice(this.vm.findings.indexOf(i), 1);
    }
  }

  // Package
  onSelectPackage(e, i?) {

    debugger
    if (this.vm.saleDetails == undefined || this.vm.saleDetails.length == 0) {
      this.vm.saleDetails = [];
    }

    // let iii = document.getElementById(this.spareParts[0].Id);
    this._uow.logger.log(e);
    let item = this.packageTypes.find(x => x.id === e.id);
    if (item !== undefined) {
      this.vm.gWareHouse = new ItemViewModel1();
      this.vm.gWareHouse.id = item.gWareHouse.id;
      this.vm.gWareHouse.name = item.gWareHouse.name;
      let selectedServicesList: any = [];
      let selectedSaprePartsList: any = [];
      if (this.vm.saleDetails != undefined && this.vm.saleDetails.length > 0) {
        this.vm.saleDetails.forEach(x => {

          if (x.itemType.name === 'Services') {
            let serviceslect = new SaveItemRequest();
            serviceslect.id = x.item.id;
            serviceslect.name = x.item.name;
            selectedServicesList.push(serviceslect);
          }
          if (x.itemType.name === 'Spare-Parts') {

            let partssSelected = new SaveItemRequest();
            partssSelected.id = x.item.id;
            partssSelected.name = x.item.name;
            selectedSaprePartsList.push(partssSelected);
          }
        })
        //this.selectedSpareParts = selectedSaprePartsList;
        //this.SelectedItemServices = selectedServicesList;
      }

      item.gPackagesItem.forEach(x => {

        let alreadyExisting = this.vm.saleDetails.find(z => z.item.id === x.ssItemDefining.id);
        if (alreadyExisting == undefined || alreadyExisting == null) {
          if (x.itemType.name === "Spare-Parts") {
            let selectedparts = this.spareParts.find(y => y.id === x.ssItemDefining.id);
            //if (selectedparts !== undefined) {
            let i = new SaleDetailModel();
            i.id = 0;
            i.quantity = x.quantity;
            i.item = new ItemViewModel1(x.ssItemDefining.id, x.ssItemDefining.name);
            i.itemCode = x.code;
            i.itemName = x.ssItemDefining.name;
            i.purchasePrice = x.salePrice;
            i.salePrice = x.salePrice;
            i.totalAmount = x.amount;
            i.rate = x.salePrice;
            i.discountedRate = x.salePrice;
            i.itemType = x.itemType;
            i.vatAmount = 0;
            i.vatValue = 0;
            i.discount = 0;
            i.discountAmount = 0;
            this.vm.saleDetails.push(i);
            let ab = new GPackageItemModel();
            ab.id = 0;
            ab.quantity = x.quantity;
            ab.discountPercentage = 0;
            ab.discountPercentage = x.discountPercentage;
            ab.ssItemDefining = new ItemViewModel1(x.ssItemDefining.id, x.ssItemDefining.name);
            ab.salePrice = 0;
            ab.salePrice = x.salePrice;
            ab.amount = 0;
            ab.amount = x.amount;
            ab.discountAmount = 0;
            if (this.itemVm.customerDiscount > 0) {
              ab.discountPercentage = this.itemVm.customerDiscount;
            }
            this.vmP.spareParts.push(ab);
            this.discountChange(ab, i);

            let partssSelected = new SaveItemRequest();
            partssSelected.id = x.ssItemDefining.id;
            partssSelected.name = x.code+"-"+x.ssItemDefining.name;
            selectedSaprePartsList.push(partssSelected);
            //}

          }

          if (x.itemType.name === "Services") {
            debugger

            let selectedservices = this.services.find(y => y.id === x.ssItemDefining.id);
            //if (selectedservices !== undefined) {
            let i = new SaleDetailModel();
            i.id = 0;
            i.quantity = x.quantity;
            i.item = new ItemViewModel1(x.ssItemDefining.id, x.ssItemDefining.name);
            i.itemCode = x.code;
            i.itemName = x.ssItemDefining.name;
            i.purchasePrice = x.salePrice;
            i.salePrice = x.salePrice;
            i.totalAmount = x.amount;
            i.rate = x.salePrice;
            i.discountedRate = x.salePrice;
            i.itemType = x.itemType;
            i.vatAmount = 0;
            i.vatValue = 0;
            i.discount = 0;
            i.discountAmount = 0;
            this.vm.saleDetails.push(i);
            let ab = new GPackageItemModel();
            ab.id = 0;
            ab.quantity = x.quantity;
            ab.discountPercentage = 0;
            ab.discountPercentage = x.discountPercentage;
            ab.ssItemDefining = new ItemViewModel1(x.ssItemDefining.id, x.ssItemDefining.name);
            ab.salePrice = 0;
            ab.salePrice = x.salePrice;
            ab.amount = 0;
            ab.amount = x.amount;
            ab.discountAmount = 0;
            if (this.itemVm.customerDiscount > 0) {
              ab.discountPercentage = this.itemVm.customerDiscount;
            }
            this.vmP.services.push(ab);
            //this.selectedServices.push(a);

            let serviceslect = new SaveItemRequest();
            serviceslect.id = x.ssItemDefining.id;
            serviceslect.name = x.code+"-"+x.ssItemDefining.name;
            selectedServicesList.push(serviceslect);
            this.discountChange(ab, i);
            //}

          }
        }

      });
      this.selectedSpareParts = selectedSaprePartsList;
      this.selectedItemServices = selectedServicesList;
    }
    console.log(e);
  }

  onDeSelectPackage(e) {
    debugger

    this._uow.logger.log(e);
    let item = this.packageTypes.find(x => x.id === e.id);
    if (item !== undefined) {
      this.selectedSpareParts = [];
      this.selectedItemServices = [];
      let selectedServicesList: any = [];
      let selectedSaprePartsList: any = [];


      item.gPackagesItem.forEach(y => {

        let c = this.vmP.spareParts.find(x => x.ssItemDefining.id === y.ssItemDefining.id);

        if (c !== undefined) {
          this.vmP.spareParts.splice(this.vmP.spareParts.indexOf(c), 1);
        }

        let a = this.vmP.services.find(x => x.ssItemDefining.id === y.ssItemDefining.id);

        if (a !== undefined) {
          this.vmP.services.splice(this.vmP.services.indexOf(a), 1);

        }

        let d = this.vm.saleDetails.find(x => x.item.id === y.ssItemDefining.id);
        if (d !== undefined) {
          this.vm.saleDetails.splice(this.vm.saleDetails.indexOf(d), 1);
        }


        this.calculateTotals();
      });
      if (this.vm.saleDetails != undefined && this.vm.saleDetails.length > 0) {
        this.vm.saleDetails.forEach(x => {

          if (x.itemType.name === 'Services') {
            let serviceslect = new SaveItemRequest();
            serviceslect.id = x.item.id;
            serviceslect.name = x.item.name;
            selectedServicesList.push(serviceslect);
          }
          if (x.itemType.name === 'Spare-Parts') {

            let partssSelected = new SaveItemRequest();
            partssSelected.id = x.item.id;
            partssSelected.name = x.item.name;
            selectedSaprePartsList.push(partssSelected);
          }
        })
        this.selectedSpareParts = selectedSaprePartsList;
        this.selectedItemServices = selectedServicesList;
      }

    }
  }

  calculateTotals() {
    debugger
    this.vmP.discountAmount = 0;
    this.vmP.serviceAmount = 0;
    this.vmP.services.forEach(x => {
      this.vmP.serviceAmount += x.amount;
      if (x.discountAmmount > 0) {
        this.vmP.discountAmount += (x.discountAmmount * x.quantity);
      }
    });

    this.vmP.partsAmount = 0;
    this.vmP.spareParts.forEach(x => {
      this.vmP.partsAmount += x.amount;
      if (x.discountAmmount > 0) {
        this.vmP.discountAmount += (x.discountAmmount * x.quantity);
      }
    });

    // this.vmP.SpareParts.forEach(x => {
    //  this.vmP.PartsAmount += x.Amount;
    //   if (x.DescountAmmount > 0) {
    //     //this.vmP.DiscountAmount += (x.Amount - x.DescountAmmount);
    //     this.vmP.DiscountAmount = x.Amount-x.DescountAmmount;
    //     this.vmP.DiscountAmount = x.DescountAmmount;
    //   }
    // });

    // this.vmP.Services.forEach(x => {
    //   //this.vmP.ServiceAmount += x.Amount;
    //   if (x.DescountAmmount > 0) {
    //     this.vmP.DiscountAmount = x.Amount-x.DescountAmmount;
    //   }
    // });

    this.vmP.packageAmount = this.vmP.partsAmount + this.vmP.serviceAmount;
  }
  openModal(template: TemplateRef<any>, lvl: number = 1) {
    if (lvl == 1) {
      this.modalRef = this._uow.modalServiceEx.show(template);
    }
    // if (lvl == 2) {
    //   this.modalRefLv2 = this._modalService.show(template);
    // }
  }

  // spare parts
  onSelectSparePart(e) {
    debugger
    if (this.vm.saleDetails == undefined || this.vm.saleDetails.length == 0) {
      this.vm.saleDetails = [];
    }
    let item = this.spareParts.find(x => x.id === e.id);
    if (item !== undefined) {
      this.vm.gWareHouse = new ItemViewModel1();
      this.vm.gWareHouse.id = item.gWareHouse.id;
      this.vm.gWareHouse.name = item.gWareHouse.name;
      let i = new SaleDetailModel();
      i.id = 0;
      i.quantity = 1;
      i.item = new ItemViewModel1(item.id, item.name);
      i.itemCode = item.code;
      i.itemName = item.name;
      i.purchasePrice = item.purchasePrice;
      i.salePrice = item.salePrice;
      i.totalAmount = item.salePrice;
      i.rate = item.salePrice;
      i.discountedRate = item.salePrice;
      i.itemType = item.itemType;
      i.vatAmount = 0;
      i.vatValue = parseInt(this.client.Vat);
      i.discount = 0;
      i.discountAmount = 0;
      this.vm.saleDetails.push(i);
      let a = new GPackageItemModel();
      a.id = 0;
      a.quantity = 1;
      a.ssItemDefining = new ItemViewModel1(item.id, item.name);
      a.discountPercentage = 0;
      a.salePrice = item.salePrice;
      a.amount = 0;
      a.amount = item.salePrice;
      a.discountAmount = item.salePrice;
      if (this.itemVm.customerDiscount > 0) {
        a.discountPercentage = this.itemVm.customerDiscount;
      }
      this.vmP.spareParts.push(a);
      this.discountChange(this.vmP.spareParts[this.vmP.spareParts.indexOf(a)]);
    }
  }

  onDeSelectSparePart(e) {

    let i = this.vmP.spareParts.find(x => x.ssItemDefining.id === e.id);
    if (i !== undefined) {
      this.vmP.spareParts.splice(this.vmP.spareParts.indexOf(i), 1);
    }
    let d = this.vm.saleDetails.find(x => x.item.id === e.id);
    if (d !== undefined) {
      this.vm.saleDetails.splice(this.vm.saleDetails.indexOf(d), 1);
    }
    this.calculateTotals();
  }

  discountChange(e, i?) {
    debugger
    let discountAMmount = ((e.discountPercentage * e.salePrice)) / 100;
    e.discountAmmount = discountAMmount;
    e.discountAmount = e.salePrice - e.discountAmmount;
    e.amount = e.discountAmount * e.quantity;
    let saledtl = this.vm.saleDetails.find(x => x.item.id === e.ssItemDefining.id);
    if (saledtl != undefined) {
      saledtl.discountAmount = e.discountAmmount;
      saledtl.discount = e.discountPercentage;
      saledtl.discountedRate = e.discountAmount;
      saledtl.totalAmount = e.amount;
    }
    this.calculateTotals();
  }

  onSelectService(e) {
    debugger
    if (this.vm.saleDetails == undefined || this.vm.saleDetails.length == 0) {
      this.vm.saleDetails = [];
    }
    // if (this.SelectedItemServices == undefined || this.SelectedItemServices.length == 0) {
    //   this.SelectedItemServices = [];
    // }
    this._uow.logger.log(e);
    let item = this.services.find(x => x.id === e.id);
    if (item !== undefined) {
      this.vm.gWareHouse = new ItemViewModel1();
      this.vm.gWareHouse.id = item.gWareHouse.id;
      this.vm.gWareHouse.name = item.gWareHouse.name;
      let i = new SaleDetailModel();
      i.id = 0;
      i.quantity = 1;
      i.item = new ItemViewModel1(item.id, item.name);
      i.itemCode = item.code;
      i.itemName = item.name;
      i.purchasePrice = item.purchasePrice;
      i.salePrice = item.salePrice;
      i.totalAmount = item.salePrice;
      i.rate = item.SalePrice;
      i.discountedRate = item.salePrice;
      i.itemType = item.itemType;
      i.vatAmount = 0;
      i.vatValue = parseInt(this.client.Vat);
      i.discount = 0;
      i.discountAmount = 0;
      this.vm.saleDetails.push(i);
      let a = new GPackageItemModel();
      a.id = 0;
      a.quantity = 1;
      a.ssItemDefining = new ItemViewModel1(item.id, item.name);
      a.discountPercentage = 0;
      a.salePrice = item.salePrice;
      a.amount = 0;
      a.amount = item.salePrice;
      a.discountAmount = item.salePrice;
      if (this.itemVm.customerDiscount > 0) {
        a.discountPercentage = this.itemVm.customerDiscount;
      }
      this.vmP.services.push(a);
      this.discountChange(this.vmP.services[this.vmP.services.indexOf(a)]);
      this.selectedItemServices = [...this.selectedItemServices];
    }


    //this.calculateTotals();
  }

  onDeSelectService(e) {

    let i = this.vmP.services.find(x => x.ssItemDefining.id === e.id);
    if (i !== undefined) {
      this.vmP.services.splice(this.vmP.services.indexOf(i), 1);
    }
    let d = this.vm.saleDetails.find(x => x.item.id === e.id);
    if (d !== undefined) {
      this.vm.saleDetails.splice(this.vm.saleDetails.indexOf(d), 1);
    }
    this.calculateTotals();
  }

  quantityChange(e, i?) {
    debugger
    //e.DiscountAmount = 0;
    e.amount = e.quantity * e.discountAmount;
    let saledetail = this.vm.saleDetails.find(x => x.item.id === e.ssItemDefining.id);
    if (saledetail != undefined) {
      saledetail.quantity = e.quantity;
      saledetail.totalAmount = e.amount;
    }
    this.calculateTotals();
  }


  // Tags
  onSelectTags(e) {
    debugger
    if (this.vm.salesTagsList == undefined || this.vm.salesTagsList.length == 0) {
      this.vm.salesTagsList = [];
    }

    this._uow.logger.log(e);
    let item = this.tags.find(x => x.id === e.id);
    if (item !== undefined) {

      let i = new TagsModel();
      i.id = item.id;
      i.name = item.name;
      i.fkTagId = item.id;
      this.vm.salesTagsList.push(i);
      // let a = new G_SaleMasterViewModel();
      // a.Id = item.Id;
      // a.Name = item.Name;
      // this.vm.SalesTags.push(i);

    }

  }

  onDeSelectTags(e) {
    let i = this.vm.salesTagsList.find(x => x.fkTagId === e.id);
    if (i !== undefined) {
      this.vm.salesTagsList.splice(this.vm.salesTagsList.indexOf(i), 1);
    }

  }

  openPreview(content) {
    this.modalRef = this._uow.modalServiceEx.show(content);
    this.modalRef.setClass('modal-lg');
    this.isPreview = true;
  }


  saveOrUpdate() {
    // this._jq.showSpinner(true);
    this.spinner.show();
    let obj = this.itemVm;
    console.log();
    debugger
    this.vm.driverName = this.itemVm.driverName;
    this.vm.driverPhone = this.itemVm.driverPhone;
    this.vm.invNumber = 1234;
    this.vm.transactionDate = new Date();
    this.vm.validity = 1;
    this.vm.gVehicle = new ItemViewModel1();
    this.vm.gVehicle.id = this.itemVm.id;
    this.vm.gVehicle.name = this.itemVm.registrationNumber;
    this.vm.gCustomer = new ItemViewModel1();
    this.vm.gCustomer.name = this.itemVm.customer.name;
    this.vm.gCustomer.id = this.itemVm.customer.id;
    this.vm.customerAcc = new ItemViewModel1();
    this.vm.customerAcc.id = this.itemVm.customer.id;
    this.vm.customerAcc.name = this.itemVm.customer.name;
    this.vm.creditAcc = new ItemViewModel1();
    this.vm.creditAcc.id = 0;
    this.vm.creditAcc.name = "";
    this.vm.statusType = new ItemViewModel1(5, "");
    this.vm.spsType = new ItemViewModel1();
    this.vm.spsType.id = 0;
    this.vm.spsType.name = "";
    this.vm.remarks = "";
    this.vm.paymentType = 1;
    this.vm.status = "";
    this.vm.invAmount = this.vmP.packageAmount;
    this.vm.paidAmount = this.vm.invAmount;
    this.vm.isPaymentDone = false;
    this.vm.isCredit = false;
    this.vm.isCounterSale = false;
    this.vm.odometer = parseInt(this.itemVm.odometer);
    this.vm.attachment = "";
    this.onChange(true);
    this.vm.isEmailRequired == true;
    this.vm.attachmentList = "";
    this._uow.gSaleService
      //.Post(this.vm)
      .SaveGSaleAsync(this.vm)
      .toPromise().then((res: any) => {
        console.log(res);
        // this._jq.showSpinner();
        this.submitted = true;
        this.onSubmitted.emit(this.submitted);
        //this.bsmRef.hide();
        // setTimeout(() => {
        //   /** spinner ends after 5 seconds */
        //   this.spinner.hide();
        // }, 5000);
        this.spinner.hide();
        Swal.fire(
          'Saved!',
          'Repair Order Created!',
          'success'
        )
        this._router.navigate(['/repair-order-list']);
        // this._router.navigate(['/repair-order-pdf', {id: res.Id}]);
      })
      .catch((error) => {
        this.spinner.hide();
        Swal.fire(
          'Error!',
          'Repair Order Not Saved!',
          'error'
        )
        this._uow.logger.log(`Promise rejected with ${JSON.stringify(error)}`);
        this.onSubmitted.emit(false);
        // this._jq.showSpinner();
        // setTimeout(() => {
        //   /** spinner ends after 5 seconds */
        //   this.spinner.hide();
        // }, 5000);
      });
  }






















































  // getModelsForBrands(e) {
  //   var ids = [];
  //   this.selectedBrands.forEach(b => {
  //     ids.push(b.Id);
  //   });
  //   this._uow.modelService.GetModelsListByBrands(ids).subscribe((res: any) => {
  //     this.models = res;
  //     if (this.selectedModels.length > 0) {
  //       this.selectedModels.forEach(m => {
  //         let f = this.models.find(x => x.Id == m.Id);
  //         this._uow.logger.log(m);
  //         if (f == undefined) {
  //           this.onModelSelected(m);
  //         }
  //       });
  //     }
  //     this._uow.logger.log(this.models);
  //   }, (error) => {
  //     this._uow.logger.log(error);
  //     this._jq.showSpinner();
  //   });
  // }

  // onModelSelected(e) {
  //   this._uow.logger.log(e.Id);
  // }



  compareFn(optionOne, optionTwo): boolean {
    if (optionOne !== undefined && optionTwo !== undefined) {
      return optionOne.id === optionTwo.id;
    }
  }






  amountChange(e, i?) {
    e.discountPercentage = ((e.discountAmmount * 100) / e.salePrice);
    this.discountChange(e, i);
    // if(this.vmP.DiscountAmount > 0){
    //
    //   this.calculateTotals();
    // }
    // if(this.vmP.DiscountAmount < 0){
    //   let discountAMmount = (e.Amount-e.DescountAmmount);
    //   e.Amount = (discountAMmount);

    // }
    this.calculateTotals();
  }



  //service
















  // onBrandSelected(e) {
  //   this.getModelsForBrands(e);
  // }

  // onBrandDeSelected(e) {
  //   this.getModelsForBrands(e);
  // }



  openModalLg(template: TemplateRef<any>, itemtype?) {
    this.ssItemVm = new GItemDefiningViewModel();
    if (itemtype == 1) {
      let i = this.itemTypes.find(x => x.Name == 'Spare-Parts');
      console.log(i)
      this.ssItemVm.FK_G_ItemType_Id = new ItemViewModel(i.Id, i.Name);
    }
    if (itemtype == 2) {
      let i = this.itemTypes.find(x => x.Name == 'Services');
      this.ssItemVm.FK_G_ItemType_Id = new ItemViewModel(i.Id, i.Name);
    }
    this.openModal(template);
    this.modalRef.setClass('modal-lg');
  }


  // extrnal components
  onItemSubmitted(e, mf) {
    this._uow.logger.log(e);
    if (e === true) {
      if (mf == this.cbrands) {
        this.getBrands();
      }
      if (mf == this.citems) {
        //this.getItems();
      }
      if (mf == this.cpackageTypes) {
        this.getPackageTypes();
      }
      if (mf == this.ccomplaintsType) {
        this.getComplaints();
      }
      if (mf == this.cmodels) {
        //this.getModelsForBrands(e);
      }
    }
  }

  // getRegNo() {
  //   this._jq.showSpinner(true);
  //   this._uow.vehicleService.GetList().subscribe((res: any) => {
  //     console.log(res);
  //     this._jq.showSpinner();
  //     this.vm.Fk_G_Vechile_Id = res.code;
  //   }, (error) => {
  //     console.log(error);
  //     this._jq.showSpinner();
  //   });
  // }

  //'Spare-Parts'
  getSpareParts() {
    this._jq.showSpinner(true);
    let model = this.itemVm.model;
    let modelid = this.itemVm.model.id;
    this._uow.gSettingService.GetItemsDropDownByTypeAsync("Spare-Parts").subscribe((res: any) => {
      this.spareParts = res.result;
      console.log(res);
      this._jq.showSpinner();
    }, (err) => {
      this._uow.logger.log(err);
      this.spareParts = [];
      this._jq.showSpinner();

    });
  }

  // getRequisitions() {
  //   this._jq.showSpinner(true);
  //   this._uow.vehicleService.GetList().subscribe((res: any) => {
  //     console.log(res.DtlList);
  //     this._jq.showSpinner();
  //     this.vehicleDetail = res.RegistraionNumber;
  //   }, (error) => {
  //     console.log(error);
  //     this._jq.showSpinner();
  //   });
  // }

  // getVehicleDetail() {
  //   //'Spare-Parts'
  //   this._jq.showSpinner(true);
  //   this._uow.vehicleService.GetById('Vehicle-Detail').subscribe((res: any) => {
  //     this.vehicleDetail = res;
  //     console.log(res);
  //     this._jq.showSpinner();
  //   }, (err) => {
  //     this._uow.logger.log(err);
  //     this.vehicleDetail = [];
  //     this._jq.showSpinner();
  //   });
  // }

  openModal1(template: TemplateRef<any>, lvl: number = 1) {
    if (lvl == 1) {
      this.modalRef = this._uow.modalServiceEx.show(template);
    }
    //  if (lvl == 2) {
    //    this.modalRefLv2 = this._modalService.show(template);
    //  }
  }

  // getSortIndexList(sIndex) {
  //   this._jq.showSpinner(true);
  //   this._uow.vehicleService.GetPagedResult(0, 50, sIndex).subscribe((res: any) => {
  //     this.vmListItems = res.DtlList;
  //     console.log(res);

  //     this._jq.showSpinner();
  //   }, (err) => {
  //     console.log(err);
  //     this._jq.showSpinner();
  //   });
  // }

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    this.openModal(template, 1);
    if (model !== undefined) {
      this.itemVm = model;
    } else {
      this.vm = new SaveSaleMasterRequest();
    }
  }

  openDeleteModel(template: TemplateRef<any>, model) {
    this.openModal(template, 1);
    if (model !== undefined) {
      this.itemVm = model;
    }
  }

  // conformDelete() {
  //   this._jq.showSpinner(true);
  //   this._uow.saleService.Delete(this.vm).subscribe((res: any) => {
  //     this.getList();
  //     //this.modalRefLv1.hide();
  //   }, (err) => {
  //     this._jq.showSpinner();
  //   });
  // }

  // getList() {
  //   this._jq.showSpinner(true);
  //   this._uow.vehicleService.GetList().subscribe((res: any) => {
  //     this.vmListItems = res.DtlList;
  //     console.log(res);
  //     this._jq.showSpinner();
  //   }, (err) => {
  //     console.log(err);
  //   });
  // }

  // input changes
  quantityOrPriceChanged(m) {
    m.TotalAmount = m.Quantity * m.PurchasePrice;
    this.updateTotals();
  }

  public TotalPayable = 0;
  public TotalVat = 0;
  public TotalPayableAfterVat = 0;
  updateTotals() {
    this.TotalPayableAfterVat = 0;
    this.TotalVat = 0;
    this.TotalPayable = 0;
    // if (this.itemVm.SaleDetails !== undefined && this.itemVm.SaleDetails.length > 0) {
    //   this.itemVm.SaleDetails.forEach(x => {
    //     this.TotalPayable += x.TotalAmount;
    //     this.TotalVat += x.VatAmount;
    //     this.TotalPayableAfterVat += (x.TotalAmount + x.VatAmount);
    //   });
    // }
  }

  //Image-Upload-Function


}
